var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed top-4 right-4 flex flex-col gap-4 z-50",attrs:{"data-testid":"post-login-alert-stack"}},[_c('MfaEnrollmentAlert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }